<template>
  <div class="fullheight">
    <el-tabs v-model="activeName" @tab-click="handleClick" v-if="tenantId && tenantId != -1">
      <el-tab-pane label="我的模板" name="first"></el-tab-pane>
      <el-tab-pane label="模板库" name="second"></el-tab-pane>
    </el-tabs>

    <div
      class="fullheight2"
      :style="{
        height: height,
        paddingTop: tenantId && tenantId != -1 ? 0 : '16px'
      }"
    >
      <div class="fullheight">
        <eco-table
          @load="loadData"
          :data="templateData"
          :page-result="pageBean"
          :selectable="false"
          :selection="false"
          quick-search-props="name,alias"
          ref="ecoTable"
          :show-export="false"
          :show-custom-column="false"
        >
          <template v-slot:toolbar>
            <el-button size="small" @click="showAddTemp()" type="primary" v-if="activeName == 'first'">添加</el-button>
          </template>
          <template>
            <eco-table-column type="index" width="50" align="center" label="序号" />
            <eco-table-column prop="name" label="模板名称" min-width="200" :show-overflow-tooltip="true" :sortable="true"> </eco-table-column>
            <eco-table-column prop="alias" label="别名" min-width="200" :show-overflow-tooltip="true" />
            <eco-table-column prop="purpose" label="模板用途" min-width="200" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ transDict(scope.row.purpose, purposeList) }}
              </template>
            </eco-table-column>
            <eco-table-column prop="status" label="状态" min-width="200" v-if="activeName == 'first'">
              <template slot-scope="scope">
                {{ transDict(scope.row.status, statusList) }}
              </template>
            </eco-table-column>
            <eco-table-column prop="version" label="版本" min-width="200" v-if="activeName == 'first'" />
            <eco-table-column label="操作" width="200">
              <template v-slot="{ row }">
                <el-dropdown v-if="activeName == 'first'" size="mini" @command="handleCommand">
                  <el-link type="primary" :underline="false" v-if="row.status"> 停用<i class="el-icon-arrow-down el-icon--right"></i> </el-link>
                  <el-link type="primary" :underline="false" v-else> 启用<i class="el-icon-arrow-down el-icon--right"></i> </el-link>

                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="row.status" @click.native="changeStatus(row)">停用</el-dropdown-item
                    ><el-dropdown-item v-if="!row.status" @click.native="!changeStatus(row)">启用</el-dropdown-item>
                    <el-dropdown-item :command="{ row: row, command: 'modify' }">编辑</el-dropdown-item>
                    <el-dropdown-item :command="{ row: row, command: 'delete' }">删除</el-dropdown-item>
                    <!--停用不能发布新版-->
                    <el-dropdown-item v-if="row.status" icon="el-icon-position" :command="{ row: row, command: 'newVersion' }">发布新版</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-link v-else type="primary" :underline="false" @click="temModify(row.id)">查看</el-link>
              </template>
            </eco-table-column>
          </template>
        </eco-table>
      </div>
      <!--模板添加-->
      <temp-add v-if="taVisible" :dialogVisible="taVisible" @beforeClose="beforeTaClose"></temp-add>
      <!--模板编辑-->
      <temp-modify
        :title="activeName == 'first' ? '编辑模板' : '查看模板'"
        :dialogVisible="tmVisible"
        :selectModel="selectModel"
        @beforeClose="beforeTmClose"
      ></temp-modify>
    </div>
  </div>
</template>

<script>
import form from '@/api/form.js'
import * as constants from './htmb/constants'
const tempAdd = () => import('@/views/form/htmb/tempAdd.vue')
const tempModify = () => import('@/views/form/htmb/tempModify.vue')
export default {
  components: {
    tempAdd,
    tempModify
  },
  data() {
    return {
      activeName: 'first',
      pageBean: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      height: '98%',
      templateData: [],
      selectUploadId: null,
      selectModel: null,
      taVisible: false,
      tmVisible: false,
      tenantId: '',
      ...constants
    }
  },
  mounted() {
    this.tenantId = typeof sessionStorage.getItem('tenantId') == 'undefined' ? sessionStorage.getItem('tenantId') : sessionStorage.getItem('currentTenantId')
    this.height = this.tenantId && this.tenantId != -1 ? 'calc(100% - 56px)' : '98%'
  },
  methods: {
    // tab切换
    handleClick(tab) {
      this.templateData = []
      this.pageBean.page = 1
      this.$refs.ecoTable.quickSearchWord = ''
      this.activeName = tab.name
      this.$refs.ecoTable.$refs.ecoTable.doLayout()
      this.loadData()
    },
    //设置默认
    setDefault(row) {
      form.setDefault(row.id, row.templateType).then((resp) => {
        if (resp.data.state) {
          this.$message({ message: resp.data.message, type: 'success' })
          this.loadData()
        } else {
          this.$message({ message: resp.data.message, type: 'error' })
        }
      })
    },
    //初始化加载
    loadData(param, cb) {
      if (!param) {
        this.pageBean.total = 0
        param = {
          pageBean: '',
          sorter: []
        }
        param.pageBean = this.pageBean
      }
      let loadUrl = ''
      if (this.activeName == 'first') {
        loadUrl = 'getContractTemplateList'
      } else {
        loadUrl = 'getIezuContractTemplateList'
      }
      form[loadUrl](param)
        .then((resp) => {
          this.templateData = []
          this.templateData = resp.rows
          this.pageBean = {
            page: resp.page,
            pageSize: resp.pageSize,
            total: resp.total
          }
        })
        .finally(() => {
          if (cb) {
            cb()
          }
        })
    },
    transDict(value, list) {
      let a = list.find((item) => item.code === value)
      return a ? a.name : ''
    },
    changeStatus(row) {
      let params = {
        id: row.id,
        status: row.status ? 0 : 1
      }
      form.getContractTemplatePublish(params).then((res) => {
        if (res.state) {
          this.$message.success(res.message)
          this.loadData()
        }
      })
    },
    handleCommand(params) {
      switch (params.command) {
        case 'modify':
          this.temModify(params.row.id)
          break
        case 'delete':
          this.temDel(params.row.id)
          break
        case 'newVersion':
          this.temNewVersion(params.row.id)
          break
      }
    },
    // 发布新版
    temNewVersion(id) {
      let params = {
        id: id
      }
      form.getDetailListByNewVersion(params).then((resp) => {
        if (resp.state) {
          this.$message({
            message: resp.message,
            type: 'success'
          })
          this.loadData(this.pageBean)
        } else {
          this.$message({
            message: resp.message,
            type: 'error'
          })
        }
      })
    },
    // 删除
    temDel(id) {
      let params = {
        id: id
      }
      form.getContractTemplateRemove(params).then((resp) => {
        if (resp.state) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.loadData(this.pageBean)
        } else {
          this.$message({
            message: '删除失败',
            type: 'error'
          })
        }
      })
    },
    // 展示添加模板
    showAddTemp() {
      this.taVisible = true
    },
    temModify(id) {
      this.selectModel = id
      this.tmVisible = true
    },
    // 关闭temp上传
    beforeTaClose() {
      this.selectModel = null
      this.taVisible = false
      this.loadData()
    },
    // 关闭temp上传
    beforeTmClose() {
      this.selectModel = null
      this.tmVisible = false
      this.loadData()
    }
  }
}
</script>
<style scoped>
.surfBtn {
  cursor: pointer;
  color: '#007AFF';
}
.fullheight2 {
}
</style>
